import React, { useContext } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui'
import { useSnackbar } from '@/components/ui/snackbar/useSnackbar'

import { useAuth } from '@/auth/useAuth'
import { DraftsContext } from '@/features/Home/components/shotlistUpload/DraftsContext'
import { copyLink } from '@/utils/copyLink'

interface SuccessScreenProps {
	taskId: string
}

export const SuccessScreen = ({ taskId }: SuccessScreenProps) => {
	const navigate = useNavigate()
	const { removeDraft } = useContext(DraftsContext)
	const { showSnackbar } = useSnackbar()
	const { isInt, isMain } = useAuth()

	const HTTPS_DEV = `https://${
		isInt ? 'cms.dev.viory.video' : isMain ? 'cms.dev.ruptly.tv' : null
	}/cms/content/videos/all`

	const HTTPS_PROD = `https://${
		isInt ? 'yascms.viory.video' : isMain ? 'newnc.ruptly.tv' : null
	}/cms/content/videos/all`

	const FINAL_LINK = window.location.hostname.includes('dev')
		? HTTPS_DEV
		: HTTPS_PROD

	const handleCopyLink = async () => {
		try {
			await copyLink(FINAL_LINK)
			showSnackbar('Copied link to clipboard')
		} catch (error) {
			console.error('Failed to copy link:', error)
		}
	}

	return (
		<div className='w-[700px] mx-auto'>
			<div className='flex flex-col gap-[10px] mb-8'>
				<div className='font-bold text-xl mb-5'>Successfully uploaded</div>
				<div className='bg-blue-50 rounded-xl flex items-center p-8 justify-between'>
					<div className='flex flex-col gap-0'>
						<span className='font-bold text-base text-blue-700'>Main</span>
						<NavLink
							onClick={() => removeDraft(taskId)}
							className='text-blue-700'
							to={FINAL_LINK}
						>
							{FINAL_LINK}
						</NavLink>
					</div>
					<Button
						classNameText='text-black rounded-[9999px] !whitespace-nowrap'
						className='bg-[#DEE9FE] px-3 py-2.5'
						onClick={handleCopyLink}
					>
						Copy link
					</Button>
				</div>
				<Button
					className='bg-black px-9 py-4 rounded-[8px] !w-auto'
					classNameText='text-[18px]'
					onClick={() => {
						removeDraft(taskId)
						navigate('/home')
					}}
				>
					OK
				</Button>
			</div>
		</div>
	)
}
